import { createRouter, createWebHistory } from 'vue-router';
import { i18n } from './main.js'; // Import the i18n instance
import { routeGuard, startDatePT, endDatePT } from './routeGuards';

import Home from './Pages/Home/HomePage.vue';
import Upload from './Pages/Upload/Upload.vue';
import Support from './Pages/Support/Support.vue';
import PreProgram from './Pages/Home/Homepagecomponents/PreProgram.vue';
import PostProgram from './Pages/Home/Homepagecomponents/PostProgram.vue';
import ReceiptTroubleshooting from './Pages/ReceiptTroubleshooting/ReceiptTroubleshooting.vue';
import QR from './Pages/QR/QR.vue';

const routes = [
  {
    path: '/',
    redirect: '/Home',
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    meta: { titleKey: 'Home' }, // Use titleKey to reference the title
    props: { startDate: startDatePT, endDate: endDatePT },
  },
  {
    path: '/Upload',
    name: 'Upload',
    component: Upload,
    meta: { titleKey: 'Upload' },
  },
  {
    path: '/Support',
    name: 'Support',
    component: Support,
    meta: { titleKey: 'Support' },
  },
    {
    path: '/QR',
    name: 'QR',
    component: QR,
    meta: { titleKey: 'QR' }, // Use titleKey to reference the title
  },
  {
    path: '/ReceiptTroubleshooting',
    name: 'ReceiptTroubleshooting',
    component: ReceiptTroubleshooting, // our.domain/Faq
    meta: { titleKey: 'ReceiptTroubleshooting' },
  },
  {
    path: '/PreProgram',
    name: 'PreProgram',
    component: PreProgram,
    meta: { titleKey: 'PreProgram', hideNav: true  },
    props: { startDate: startDatePT },
  },
  {
    path: '/PostProgram',
    name: 'PostProgram',
    component: PostProgram,
    meta: { titleKey: 'PostProgram', hideNav: true  },
    props: { endDate: endDatePT },
  },
  { path: '/:notFound(.*)', redirect: '/Home' },
];

// Create the router
const router = createRouter({
  linkActiveClass: 'active',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Dynamically set page title based on route
router.beforeEach((to, from, next) => {

  const pageTitleKey = to.meta.titleKey; // Access the title key
  if (pageTitleKey) {
    const translatedTitle = i18n.global.t(`titles.${pageTitleKey}`); // Fetch translated title using i18n
    document.title = translatedTitle || 'Default Title'; // Set the page title dynamically
  }
  next();
});

router.beforeEach(routeGuard);

export default router;
